import { ILayoutInfo } from '../../../interface/concretes/layout-info.interface';

export class LayoutInfo implements ILayoutInfo {
  private _stepShow: number;
  private _title: string;
  private _subtitle: string;
  private _breadcrumb?: string;

  constructor(stepShow: number, title: string, subtitle: string, breadcrumb?: string) {
    this._stepShow = stepShow;
    this._title = title;
    this._subtitle = subtitle;
    this._breadcrumb = breadcrumb;
  }

  get stepShow() {
    return this._stepShow;
  }

  set stepShow(value: number) {
    this._stepShow = value;
  }

  setStepShow(value: number) {
    this._stepShow = value;
  }

  get title() {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  setTitle(value: string) {
    this._title = value;
  }

  get subtitle() {
    return this._subtitle;
  }

  set subtitle(value: string) {
    this._subtitle = value;
  }

  setSubtitle(value: string) {
    this._subtitle = value;
  }

  get breadcrumb() {
    return this._breadcrumb ?? '';
  }

  set breadcrumb(value: string) {
    this._breadcrumb = value;
  }
}
